export interface Workspace {
  code: string;
  name: string;
}

export interface WorkspaceUrls {
  adoProject: string;
  repoUrl: string;
  pipelinesUrl: string;
  workItemsUrl: string;
  wikiUrl: string;
  sharepointUrl: string;
  teamsUrl: string;
}

const MISSION_CONTROL_BASE = 'https://missioncontrol.services.talxis.com';
const ADO_ORG = 'thenetworg';
const SP_TENANT = 'thenetworg';

export function getWorkspaceUrls(code: string): WorkspaceUrls {
  return {
    adoProject: `https://dev.azure.com/${ADO_ORG}/${code}`,
    repoUrl: `https://dev.azure.com/${ADO_ORG}/${code}/_git/${code}`,
    pipelinesUrl: `https://dev.azure.com/${ADO_ORG}/${code}/_build`,
    workItemsUrl: `https://dev.azure.com/${ADO_ORG}/${code}/_workitems`,
    wikiUrl: `https://dev.azure.com/${ADO_ORG}/${code}/_wiki`,
    sharepointUrl: `https://${SP_TENANT}.sharepoint.com/teams/${code}`,
    teamsUrl: `https://${SP_TENANT}.sharepoint.com/teams/${code}`,
  };
}

export async function fetchWorkspaces(): Promise<Workspace[]> {
  const res = await fetch(`${MISSION_CONTROL_BASE}/workspaces`);
  if (!res.ok) throw new Error(`Failed to fetch workspaces: ${res.status}`);
  const data: { value: Workspace[] } = await res.json();
  return data.value;
}

export function getWorkspaceDisplayName(ws: Workspace): string {
  return `${ws.code} — ${ws.name}`;
}
